import React from "react";
import { Button, Col } from "reactstrap";

export default function ObOpportunityComingSoon(props) {
  const { isMobile } = props;  

  return (
    <Col style={{boxShadow: '0px 4px 30px rgba(0,0,0,0.15)'}} className="opp-base" lg={!isMobile ? 4 : {}}>
      <div className="card-header">
        <div className="card-sub d-flex align-items-center">
         <p>Coming Soom</p>
        </div> 
      </div>
      <div className="card-opp-body">
          <p className="opp-desc">
          Lorem Ipsum is simply dummy text of the printing and 
          typesetting industry. Lorem Ipsum has been the 
          industry's standard dummy text ever since the
        </p>
        <div className="divider" />
        <div className="d-flex align-items-center justify-content-between">
         <p className="opp-desc text-secondary font-weight-semi-bold mt-3">
          Maturity Date: Coming Soon
         </p>
        </div>
        <div className="d-flex align-items-center justify-content-between">
          <div className="details">
            <div>
              <p>Min Investment Amount</p>
              <p>{(props.opportunity && props.opportunity.minAmt) ? props.opportunity.minAmt.oroNumber(2, true) : 'NA'}</p>
            </div>
            <div>
              <p>Principal payout</p>
              <p>Coming Soon</p>
            </div>
          </div>
          <div className="divider-hr"/>
          <div className="details">
            <div>
              <p>YTM</p>
              <p>Coming Soon</p>
            </div>
            <div>
              <p>Interest payout</p>
              <p>Coming Soon</p>
            </div>
          </div>
        </div>
        <div className="btn-container">
          <Button disabled >
            View Details
          </Button>
        </div>
      </div>
      <div className="blur">
        <div className="div-1">
          <p>Coming Soon</p>
        </div>
        <div className="div-2">
        </div>
      </div>
    </Col>
  );
}
